import AnimationController from '../controllers/animation';

// add 'is-active' class immediately, wait one animation frame then add 'is-in' class

export default function ($el, classActive = 'is-active', classIn = 'is-in') {
	return new Promise((resolve) => {
		$el.classList.add(classActive);
		AnimationController.one({
			update: () => true,
			render: () => {
				$el.classList.add(classIn);
				resolve();
			}
		});
	});
}
